import { lightTheme } from '@/customTheme'
import { styled } from 'baseui'

const Title = styled('div', (props: { $fluid: boolean }) => ({
    width: props.$fluid ? '100%' : '292px',
    height: props.$fluid ? '20px' : '26px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: props.$fluid ? '12px' : '8px',
}))

function InspectorSectionTitle({ title, fluid = false } : { title: string; fluid?: boolean }) {
    return (
        <Title $fluid={fluid}>
            <span style={{ ...lightTheme.typography.Small14Semibold, color:lightTheme.colors.text.text_black_title, textTransform: fluid ? 'none' : 'capitalize' }}>{title}</span>
        </Title>
    )
}

export default InspectorSectionTitle
